<h1 mat-dialog-title>Confirm action delete</h1>
<mat-dialog-content>
    <p class="mat-body">
        You are going to delete <strong>{{data.action?.title}}</strong> action.
    </p>
    <br>
    <p class="mat-body">Please confirm.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="warn" mat-dialog-close="delete"
        (click)="deleteAction()">
        Delete
    </button>
</mat-dialog-actions>
